/**
 * 接口域名的管理
 */
// 正式配置
// const base = {
//
//   //sq:'/api',//请求代理需要用到
//     sq:'http://wechat.nxptdn.com',
//     bd: 'http://operator.nxptdn.com',
//     client:'http://e.nxptdn.com',
//     appid:'wx9e5e67da26c51a14'
// }


//演示环境 
const base = {
  sq: '/api',//请求代理需要用到
  // bd: 'http://127.0.0.1:9250',
  bd: 'https://platform.fanteeng.com/apipro',
  
  client: 'https://api.fanteeng.com',
  // client: 'http://192.168.31.148:8080',
  
  appid: 'wx1374965c6e257fc1'
}





export default base;


